export default {
  'apply.policy.agreeTip': ' I have read, understood, and confirmed the contents of the dataset privacy agreement',
  'apply.policy.agree': 'Please tick the agreement option',
  'apply.form.label.name': 'Name',
  'apply.form.label.email': 'Email',
  'apply.form.label.org': 'Organization',
  'apply.form.label.profession': 'Profession',
  'apply.form.label.purpose': 'Usage',
  'apply.form.label.desc': 'Detailed Description of Use',
  'apply.form.label.policy': 'By submitting this application, you agree to the',
  'apply.form.label.policy.service': "platform's User Service Agreement",
  'apply.form.label.policy.privacy': ' Privacy Policy',
  'apply.form.placeholder.email': 'Please fill in the email. We will feedback the application result to your email',
  'apply.form.placeholder.name': 'Please fill in your name',
  'apply.form.placeholder.org': 'Please fill in your organization',
  'apply.form.placeholder.profession': 'Please fill in your identity',
  'apply.form.placeholder.purpose': 'Please fill in your name',
  'apply.form.placeholder.desc': 'Detailed description of the usage of the dataset',
  'apply.form.rule.email': 'The email format is wrong, please modify it.',
  'apply.form.required.email': 'Please fill in the email',
  'apply.form.required.name': 'Please fill in your name',
  'apply.form.required.org': 'Please fill in your organization',
  'apply.form.required.profession': 'Please fill in your identity',
  'apply.form.required.purpose': 'Please choose the usage of the dataset',
  'apply.form.cancel': 'cancel',
  'apply.button.popover':
    'We will send the application authorization email to the dataset owner, and then feedback the application result to your email',
  'apply.form.purpose.1': 'Educational',
  'apply.form.purpose.2': 'Commercial',
  'apply.form.purpose.3': 'Research and Publication',
  'apply.form.purpose.4': 'Competition',
  'apply.form.purpose.5': 'Others',
  'apply.form.res.front': 'The approval results and download links will be sent to your email,',
  'apply.form.res.end': 'please wait patiently',
  'apply.form.second': 'seconds',
  'apply.form.second.left': 'Remaining',
  'apply.form.next': 'next',
  'apply.form.apply': 'Apply for',
  'apply.form.submit': 'submit',
  'apply.form.datasetAuth': 'Dataset Access',
  'apply.button.applyForDownload': 'Apply to download',
  'apply.form.submit.error': 'Error, Please try again later',
  'apply.form.submit.success': 'Success',
  'apply.form.submit.success.confirm': 'OK',
  'cli.step.tip1': 'Welcome to OpenXLab/OpenDataLab. After logging in, you can add a key to download using CLI/SDK',
  'cli.step1.signin': 'Sign in',
  'cli.step1.signup': 'Sign Up',
  'cli.step.tip2': 'Please {tip2Link} first to use the CLI/SDK download method.',
  'cli.step.tip2.link': 'fill in the user information',
  'cli.step.tip2.waiting': 'Application under review, can use CLI/SDK download upon approva',
  'cli.step.tip.aksk1': 'There is currently no key available. Please go to the key management to add the key',
  'cli.step.tip.aksk2':
    'To pass identity verification when accessing the platform using CLI/SDK, please add the Access Key ID and Secret Access Key first. Add the keys.',
  'cli.step.tip.aksk3':
    'To pass identity verification, you can view your Access Key ID and Secret Access Key in {keyManage}',
  'cli.step.keyManage': 'Key Manage',
  'cli.step.aksk.add': 'Add Key',
  'cli.step.aksk.tip': "Don't remind",
  'cli.download': 'Download',
  'cli.annotation.install': 'Install',
  'cli.annotation.upgrade': 'Upgrade',
  'cli.annotation.login': 'Log in and enter the corresponding AK/SK',
  'cli.annotation.info': 'Dataset information viewing',
  'cli.annotation.ls': 'View Dataset File List',
  'cli.annotation.get': 'Dataset download',
  'cli.annotation.download': 'Dataset file download',
  'cli.firstDownload.tip': "First download? Click 'Download' for form fill-out.",
  'cli.annotation.info.list': 'Dataset information viewing and View Dataset File List',
  'cli.md.tip1': 'Log in and enter the corresponding AK/SK. Please add AK/SK at {tip1Link}',
  'cli.md.tip1.link': 'usercenter',
  'cli.md.tip2': 'Log in and enter the corresponding AK/SK. Please view  AK/SK at {tip2Link}',
  'cli.md.tip2.link': 'usercenter'
};
